import {authorized} from "./ApiClient";
import {send} from "./http";
import {NewUserBindingModel, UpdateUserBindingModel, UserViewModel} from "./models";

const user = (username: string) => `/user/${encodeURIComponent(username)}`;

export const UsersApi = {
    // Administration (SiteAdmin)
    getAll: () => authorized<UserViewModel[]>('GET', '/user'),

    // The API generates a password and emails it to the user.
    create: (model: NewUserBindingModel) => authorized<UserViewModel>('POST', '/user', model),

    get: (username: string) => authorized<UserViewModel>('GET', user(username)),

    update: (username: string, model: UpdateUserBindingModel) => authorized<UserViewModel>('PUT', user(username), model),

    remove: (username: string) => authorized<void>('DELETE', user(username)),

    // Generates a new password, emails it, and re-enables the account.
    resetPassword: (username: string) => authorized<void>('PUT', `${user(username)}/reset-password`),

    // Self-service, signed out. Always succeeds, so it doesn't reveal which addresses have accounts.
    forgotPassword: (emailAddress: string) => send<void>('POST', '/user/forgot-password', { emailAddress }),

    // From the emailed link (valid 10 minutes).
    resetForgottenPassword: (token: string, newPassword: string) => send<void>('POST', '/user/reset-password', { token, newPassword })
};
